import { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import CustomText from "../components/CustomText";

const Counter = ({
  end,
  duration = 2000,
  prefix = "",
  suffix = "",
  sx = {},
}) => {
  const [count, setCount] = useState(0);
  const [visible, setVisible] = useState(false);

  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      {
        threshold: 0.5,
      },
    );

    observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!visible) return;

    let start = 0;

    const increment = end / (duration / 16);

    const timer = setInterval(() => {
      start += increment;

      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);

    return () => clearInterval(timer);
  }, [visible, end, duration]);

  return (
    <Box ref={ref}>
      <CustomText sx={sx}>
        {prefix}
        {count.toLocaleString("es-MX")}

        {suffix &&
          suffix.split("\n").map((line, index) => (
            <Box key={index} component="span" display="block">
              {line}
            </Box>
          ))}
      </CustomText>
    </Box>
  );
};

export default Counter;
